module.exports = __webpack_public_path__ + "static/img/1.f3600c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nationalDay/card/1.png
// module id = AdiL
// module chunks = 2